export default __webpack_public_path__ + "static/Micro-Fibre-Pillow 2-4f4780f9159f1ebe29dc9bd5c38cac7b.png";